import { call, put } from 'redux-saga/effects';
import { fetchVPOReportCompletedActionsSuccess, fetchVPOReportCompletedActionsFailure, FetchVPOReportCompletedActionsRequest } from './actions';
import { getReportCompletedActionsData } from '../../api/api';

export function* fetchVPOReportCompletedActionsSaga(action: FetchVPOReportCompletedActionsRequest) {
  try {
    const { filters } = action.payload;

    const params = {
      columnId: (filters.columnReportAction?.selectedIds || []).map(String),
      groupIds: filters.groupReportPeriod?.selectedIds || [],
      factoryIds: filters.factoryReport?.selectedIds || [],
      year: filters.year?.selected?.[0] || new Date().getFullYear().toString(),
      departmentIds: filters.department?.selectedIds || [],
    };

    const response: any = yield call(getReportCompletedActionsData, params);

    if (response.success) {
      yield put(fetchVPOReportCompletedActionsSuccess(response.data));
    } else {
      // console.error('Ошибка в ответе', response.error);
      yield put(fetchVPOReportCompletedActionsFailure(response.error || 'Ошибка загрузки'));
    }
  } catch (error: any) {
    // console.error('Saga ошибка:', error);
    yield put(fetchVPOReportCompletedActionsFailure(error?.message || 'Ошибка сети'));
  }
}
